import { themr } from 'react-css-themr';
import prefixer from 'react-toolbox/lib/utils/prefixer';
import { ProgressBar } from 'react-toolbox/lib/progress_bar/ProgressBar';
import theme from 'react-toolbox/lib/progress_bar/theme.scss';
import verticalTheme from './vertical.scss';

class VerticalProgressBar extends ProgressBar {
    linearStyle() {
        if (this.props.mode !== 'indeterminate') {
            return {
                buffer: prefixer({
                    transform: `scaleY(${this.calculateRatio(
                        this.props.buffer
                    )})`
                }),
                value: prefixer({
                    transform: `scaleY(${this.calculateRatio(
                        this.props.value
                    )})`
                })
            };
        } else {
            return {};
        }
    }
}

const ThemedVerticalProgressBar = themr(
    'VerticalProgressBar',
    verticalTheme
)(themr('ProgressBar', theme)(VerticalProgressBar));
export default ThemedVerticalProgressBar;
export { ThemedVerticalProgressBar as VerticalProgressBar };
